// Fixed header stack: measure its height and pad the page so content isn't covered
(function() {
  var stack = document.querySelector('.ff-sticky-stack');
  if (!stack) return;
  function setStackHeight() {
    document.documentElement.style.setProperty('--ff-stack-h', stack.offsetHeight + 'px');
  }
  setStackHeight();
  window.addEventListener('resize', setStackHeight);
  window.addEventListener('load', setStackHeight);
  if (window.ResizeObserver) new ResizeObserver(setStackHeight).observe(stack);
})();

// Hero carousel (arrows + counter)
var track = document.getElementById('carouselTrack');
var prevBtn = document.getElementById('carouselPrev');
var nextBtn = document.getElementById('carouselNext');
var counter = document.getElementById('carouselCounter');
if (track && prevBtn && nextBtn) {
  var totalSlides = track.children.length;
  var currentSlide = 0;
  var ffVideo = document.getElementById('ffVideo');
  var updateCarousel = function() {
    track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
    if (counter) counter.textContent = (currentSlide + 1) + ' / ' + totalSlides;
    if (currentSlide !== 0 && ffVideo && !ffVideo.paused) ffVideo.pause();
  };
  prevBtn.addEventListener('click', function() {
    currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
    updateCarousel();
  });
  nextBtn.addEventListener('click', function() {
    currentSlide = (currentSlide + 1) % totalSlides;
    updateCarousel();
  });
}

// FAQ accordion
document.querySelectorAll('.faq-question').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var item = btn.parentElement;
    var wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  });
});

// Reveal on scroll
var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (entry.isIntersecting) entry.target.classList.add('visible');
  });
}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('.reveal').forEach(function(el) { observer.observe(el); });

// Bottom CTA bar — visible whenever the real Add to cart button is off screen.
// (It used to watch the whole buy box, so it only appeared after you had already
// scrolled past the button — useless to anyone still on their way down to it.)
var stickyCta = document.getElementById('stickyCta');
if (stickyCta) {
  var mainCta = document.querySelector('.ff-ph-cta');
  var comingSoon = document.querySelector('.ff-ph-soon');
  if (comingSoon && !mainCta) {
    // Nothing to buy on this page — never offer a bar that cannot work.
    stickyCta.remove();
  } else if (mainCta && 'IntersectionObserver' in window) {
    var stickyObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyCta.classList.toggle('show', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObs.observe(mainCta);
  } else {
    var onScroll = function() {
      stickyCta.classList.toggle('show', window.scrollY > 500);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
}

// Smooth scroll
document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    var target = document.querySelector(this.getAttribute('href'));
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});
